import axios from 'axios';

import { CompanySignUpDto } from '../interfaces/company-sign-up.dto';
import { CompanyDto } from '../interfaces/company.dto';

class CompanyService {
  async loadCompany(): Promise<CompanyDto> {
    return (await axios.get<CompanyDto>('company')).data;
  }

  async sendCompanyOnboardingInfo(payload: CompanySignUpDto, companyId: string): Promise<void> {
    await axios.post(`company/sign-up-info/${companyId}`, payload);
  }
}

export default new CompanyService();
